import DetailAddonInfoContainer from '../../atoms/container/detailAddonInfoContainer';
import DetailAddonInfoLeft from '../../elements/addons/detailAddonInfoLeft';
import DetailAddonInfoRight from '../../elements/addons/detailAddonInfoRight';

function DetailAddonInfo() {
  return (
    <DetailAddonInfoContainer>
      <DetailAddonInfoLeft></DetailAddonInfoLeft>
      <DetailAddonInfoRight></DetailAddonInfoRight>
    </DetailAddonInfoContainer>
  );
}

export default DetailAddonInfo;
